export function Sk({ className = '' }) {
  return (
    <div className={`animate-pulse bg-brand-surface-container-high dark:bg-brand-on-surface/70 rounded-md ${className}`} />
  );
}
